import React, { useEffect, useState } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Image from "../../Components/Reusable/Image";
import { SvgImages } from "../../Utils/LocalImages";

function CustomDatePicker({
  name,
  register,
  labelTitle,
  showError,
  errorMessage,
  setValue,
  resetValue,
  setResetValue,
  defaultOption,
  showMandatory = false,
  isWhiteTheme = false, // Default theme is dark
  ...props
}) {
  const [selectedDate, setSelectedDate] = useState(defaultOption);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    setValue(name, date, { shouldValidate: true });
  };

  const CustomTextField = () => (
    <div className="custom-date-picker-textfield">
      <Image src={SvgImages.datepickerlogo} className="custom-date-picker-logo" style={{ width: 24 }} />
    </div>
  );

  useEffect(() => {
    if (resetValue) {
      setResetValue(false);
      if(setValue) setValue(name, null);
      setSelectedDate(null);
    }
  }, [resetValue]);

  return (
    <div className="form-group d-flex flex-column">
      <h3 className="fw-600 medium-text mb-0">
        {labelTitle}
        {showMandatory ? <span className="danger">*</span> : null}
      </h3>
      <div className="d-flex flex-column">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            {...props}
            value={selectedDate}
            disableFuture={true}
            {...(register ? register(name) : {})}
            onChange={handleDateChange}
            views={['year', 'month', 'day']}
            format="DD/MM/YYYY"
            slotProps={{
              textField: { variant: 'standard' },
              openPickerIcon: { component: CustomTextField }
            }}
          />
        </LocalizationProvider>
      </div>
      {showError ? <span className="danger small-text fw-400 mt-2">{errorMessage}</span> : null}
    </div>
  );
}

export default CustomDatePicker;
